const page = `

{settings}
document.title: Hyrestestet - Tack för ert engagemang!
og.title: Hyrestestet - Tack för ert engagemang!
og.image: http://pejl.svt.se/hyrestestet/images/formular.jpg
og.description: Fler än 53.000 personer från hela landet gjorde vårt test, och av dem valde fler än 6.500 att skriva in sina personliga berättelser och erfarenheter till oss. Tack!
og.url: http://pejl.svt.se/hyrestestet-tack/
siteCatalyst.name: HyrestestetTack
siteCatalyst.category: lyxartikel
{}

[+page]

{.special}
component:header
storlek:l
{}

Alla era berättelser har blivit lästa, antingen av oss som jobbat med [hyrestestet | http://pejl.svt.se/hyrestestet] eller de lokala stationer vi har runt om i landet. Många nyheter har gjorts av era erfarenheter, både i tv och på svtnyheter.se. Vi har med hjälp av er kunnat lyfta fram flera enskilda fall och belysa några av de utmaningar och svårigheter som kan uppstå när man hyr sin bostad.

{.video}
id:8299764
storlek:m
{}

special:hus

rubrik4: Med er hjälp kan vi berätta
Vi har kategoriserat 2.000 slumpmässigt utvalda svar, för att se vilka mönster som finns, vad ni väljer att lyfta fram och fokusera på i era berättelser till oss. Det här är vad ni har velat säga, och därmed vad vi vill berätta:

{.special}
component:Avdelare
text: ”Jag var hemlös i tolv år innan jag fick en helt egen lägenhet. Jag bodde på soffor, i andra hand, i tredje hand och ibland på allmänna toaletter. Till slut fick jag äntligen lägenheten jag bor i nu och jag tog den direkt utan att se den. Jag är så glad nu att jag har en lägenhet som bara är Min.”
bild: soffa
storlek:text
{}

Många av er har kämpat länge och utstått mycket för att hitta ett eget hem. Många av er kämpar fortfarande, växlar mellan olika boenden och har av olika anledningar svårt att få en egen bostad.
Anledningarna varierar, men de främsta skälen ni anger är att det inte finns lägenheter att hyra eller att er ekonomiska situation inte räcker till för ett förstahandskontrakt eller för att köpa bostad.

{.special}
component:Avdelare
text: ”Helt omöjligt att få bostad om det inte är via kontakter. Man får bara andrahandskontrakt, och det årsvis. Förstahandskontrakt? Börja slå rot? Helt omöjligt.”
bild: kontakter
storlek:text
{}

Bristen på lägenheter är uppenbar, kötider på upp mot tio år räcker inte på många platser i landet – speciellt inte om man vill kunna välja vilken sida av staden man vill bo på. Flera av er bor i orter och i lägenheter där ni inte alls trivs men som ni inte kan ta er ifrån.
luft:50px

rubrik4: Höga krav från hyresvärdar
Ekonomin spelar som sagt också en stor roll. Det kan handla om gamla betalningsanmärkningar som gör det svårt att få lån, att hyresvärdarna har krav om en årsinkomst som är svår att matcha eller att man inte har en fast anställning.

{.special}
component:Avdelare
text: ”Hur ska vi med osäkra anställningar kunna få en bostad, när majoriteten av hyresvärdarna inte nöjer sig med en fläckfri ekonomisk bakgrund och intyg från tidigare hyresvärdar. Utan även ställer krav på en viss lönenivå plus fast anställning. Jag har under de tolv år som gått sedan flytten hemifrån ALDRIG varit sen med att betala min hyra.”
bild: anstallning
storlek:text
{}

Men även för er som har en bostad, både i förstahand, andrahand och som inneboende, är ekonomin ofta ett problem. Dyra hyror som slukar en stor del av inkomsten och kraftigt begränsar var och hur ni kan bo.

luft:50px

rubrik4: Så ser hyrorna ut län för län

Utifrån svaren har vi räknat ut medelpriset per kvadratmeter uppdelat på län. Så här ser hyrorna ut i landet enligt er som gjort testet.

{.iframe}
src: https://charts.datawrapper.de/TCTaT/index.html
storlek:page
height:800px
{}

Flera av er som hört av er är pensionärer som vittnar om att ni varken har råd att bo kvar eller flytta ut när hyrorna höjs och pensionerna sänks. I många fall går mer än halva pensionen åt till hyran och det blir inte mycket kvar att leva på. Er oro för framtiden är stor – och den delas av flera av landets studenter.

{.special}
component:Avdelare
text: ”Som student så har man nästan inte längre något annat val än att vara inneboende eller dela lägenhet, priserna går upp, upp, upp och det finns knappt någon chans att man ska kunna köpa en lägenhet när 18 kvadratmeter har ett utgångspris på 1,2 miljoner. Med tanke på bostadsköerna och det möjliga amorteringskravet så är jag tvungen att flytta hem till mina föräldrar igen efter att jag har tagit examen...”
bild: student
storlek:text
{}

Att tvingas flytta hem till sina föräldrar, syskon, mormor eller annan familj är ganska vanligt bland er som skrivit till oss. Det är en sak att som ung mellanlanda en period hos sina föräldrar – vissa av er trivs till och med väldigt bra med det – men att till exempel bli kvar hos en före detta flickvän eller pojkvän för att det inte finns någonstans att ta vägen tär. En kvinna som hört av sig till oss sover sen ett antal månader tillbaka på en madrass i sina barns rum hos sitt ex. Flera av er har en boendesituation som ni känner är mindre bra för era barn. En kvinna flyttade runt med sin tvååriga dotter i tre månader innan hon fick tag i ett gammalt torp att hyra. Det är trångt och kallt och för att ta sig mellan huset, dagis och jobbet får hon köra 14 mil om dagen.



{.special}
component:Avdelare
text: ”En del av mig tänker att jag är glad att jag kan erbjuda min dotter tak över huvudet och vi dör inte av kalla golv, dåligt vatten, lite möss och extra körning.”
bild: mil
storlek:text
{}


Hennes, trots allt, positiva inställning är något som återkommer i många av era berättelser. Ni är många som valt alternativet ”Mycket nöjd” på frågan om hur ni trivs med er boendesituation. Men en betydande del av er har enligt era berättelser all anledning att klaga. Värdar som inte svarar på samtal, alldeles för låga temperaturer på vintern, mögel i badrum och trasiga golv och vitvaror. Det är bara några av de saker ni som är mycket nöjda får stå ut med.
luft:50px

rubrik4: Så nöjda är ni med boendet

{.iframe}
src: http://datawrapper.dwcdn.net/qMuFg/1/
storlek:m
height:400px
{}
Drygt 65 procent av alla som gjort vårt test anger att ni är nöjda eller mycket nöjda med er boendesituation. Mest nöjda är föga förvånande ni som har ett eget förstahandskontrakt. Minst nöjda är ni som bor som inneboende. Men era berättelser ger som sagt en splittrad bild, och många av er är nöjda trots ganska stora problem med till exempel standard och hyresvärdar.
luft: 50px
rubrik4: Dålig standard inte alltid låg hyra
Inställningen är att man får vara glad att man har någonstans att bo överhuvudtaget. Ibland går det så långt så att man inte ens talar om för värden om alla de problem som finns – man vill inte klaga och vara besvärlig och därmed riskera att bli vräkt. Även lägenheter i dåligt skick hittar nya hyresgäster snabbt i de många områden.
{.special}
component:Avdelare
text: ”Jag bor i Luleå och det har under mina fem år i min lägenhet aldrig rustas mer än en ny fläkt. Köksluckorna går sönder och går inte att rengöra ordentligt. Det är hål i väggen i den gemensamma tvättstugan sen cirka tre år tillbaka och det finns knappt en asfaltfläck på utegården som är platt. Det är hål och gupp överallt. Jag skulle vilja veta var pengarna jag betalar i hyra varje månad går till? För där jag bor går dom inte till i alla fall.”
bild: koket
storlek:text

{}

Vad hyran går till är ni många med förstahandskontrakt som undrar, känslan av att de inte används på rätt sätt är återkommande – speciellt hos er som har väldigt låg standard i era lägenheter. Hyresvärdar som inte svarar i telefon, som ger tomma löften eller som höjer hyran regelbundet utan att någon förbättring görs i lägenheten återkommer bland era svar. Känslan av att betala för mycket för sitt boende finns i alla tre grupper, men det är ni utan förstahandskontrakt som betalar mest.

rubrik4: Så mycket betalar ni i hyra per kvadratmeter

{.iframe}
src: http://datawrapper.dwcdn.net/8a9Xx/1/
storlek:m
height:200px
{}

luft:50px
rubrik4: Tack för ert engagemang

Slutligen vill vi återigen tacka alla er som tagit er tiden att göra hyrestestet, och ett extra tack till er som också skrivit in personliga berättelser och reflektioner. Ni har hjälpt oss visa hur bostadsmarknaden ser ut över landet och vi har lyft era berättelser och erfarenheter efter bästa förmåga. Många av er har uppmuntrat oss i vår granskning och några av er har skällt på oss. En handfull av er har busat med oss, kanske för att se om vi verkligen läser allas svar. Det gör vi, och det här citatet får avrunda vår rapportering för den här gången.

special:hus

citat: Asså jag känner såhär, om man har tillgång till stort har man också tillgång till ännu större. Det är så jag känner. Så om ni bara liksom kan bygga större till mig skulle det vara jättebra! Men nu tycker jag att jag kanske kan berätta lite om hur jag har det. Jag har ett stort hus men man kan ju aldrig ha för stort. Jag har en pool på taket, så jag skulle vilja att ni är försiktiga med poolen när ni bygger ut mitt hus. Tack, och tack för att ni önskar mig ett skönt liv. Ni kan komma cirka klockan två på lördag och börja! Adjöss.

text:Av: [Fredrik Edgren |  mailto:fredrik.edgren@svt.se ], [Jens Falkman-Lundberg |  mailto:jens.falkman-lundberg@svt.se], [Martin Hedström | mailto:martin.hedstrom@svt.se], [Linnea Heppling | mailto:linnea.heppling@svt.se], [Ella Hopf Berger | mailto:ella.berger@svt.se] och [Robin Linderborg | mailto:robin.linderborg@svt.se]

{.sharebuttons}
title:Hyrestestet - Fler än 53.000 personer från hela landet gjorde vårt test. Tack!
url:http://pejl.svt.se/hyrestestet-tack/
{}
[]
`;

export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/hyrestestet.js
 **/